import React, { useState } from 'react';
import PropTypes from 'prop-types';

import PrimaryBtn from 'components/Buttons/PrimaryBtn';
import PasswordInput from 'components/Inputs/PasswordInput';
import TextDescInput from 'components/Inputs/TextDesc';

const ChangeEmailModal = ({ submitHandler }) => {
  const [password, setPassword] = useState();
  const [email, setEmail] = useState();

  const onClick = () => {
    submitHandler({ email, password });
  };

  return (
    <div className="p-8">
      <div className="space-y-5 mb-5">
        <PasswordInput
          header="Enter password"
          placeholder="Enter your password"
          value={password}
          onChange={setPassword}
        />
        <TextDescInput
          type="email"
          header="New email"
          placeholder="Enter your new email"
          value={email}
          onChange={setEmail}
        />
      </div>

      <div className="bg-zinc-50 dark:bg-zinc-900 dark:border-zinc-700 border-t  px-3 rounded-b-lg -mb-8 -mx-8 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
        <div className="mr-2 space-x-3">
          <PrimaryBtn text="Update email" onClick={onClick} />
        </div>
      </div>
    </div>
  );
};

ChangeEmailModal.propTypes = {
  onClose: PropTypes.func,
  submitHandler: PropTypes.func,
};

ChangeEmailModal.defaultProps = {
  onClose: () => null,
  submitHandler: () => null,
};

export default ChangeEmailModal;
